module.exports = __webpack_public_path__ + "img/book2-2.795bf9c6.jpg";